export default "__VITE_ASSET__83b21d10__"